import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./dashboardSidebar.css";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useCallback } from "react";


const DashboardSidebar = () => {
  const location = useLocation();
  const loginuser = useSelector((state) => state.setUserlog);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);
  
  // Hide sidebar on join-auction-code3 page for all users
  const shouldHideSidebar = location.pathname === '/join-auction-code3';
  
  function acpgo() {
    //  console.log("valllllllllll")
    //  console.log(cid + " " + token)
    // Build URL with query parameters for GET request
    // const baseUrl = "https://superplayerauction.com/manage/?frnt=1";
    const currentDomain = window.location.origin; 
    const baseUrl = `${currentDomain}/manage/?frnt=1`;
    const params = new URLSearchParams({
      cid: cid,
      aid: 0,
      fkey: token
    });
    const url = `${baseUrl}&${params.toString()}`;
    
    // Open in new tab
    window.open(url, '_blank');
  }
  
  // Don't render anything if sidebar should be hidden
  if (shouldHideSidebar) {
    return null;
  }
  
  return (
    loginuser!=0 && 
    <div className="dashboardSidebar-container">
      <form id="acpform" method='post' action="https://superplayerauction.com/manage/?frnt=1" target="_blank">
        <input type="hidden" id="acp1" name="cid" />
        <input type="hidden" id="acp2" name="aid" />
        <input type="hidden" id="acp3" name="fkey" />
        {/* <input type="hidden" name="loginbyadmin" value="1" /> */}

      </form>
      <div className="dashboardSidebar-wrapper">
        <Link to="/Dashboard">
          <div className="dashboardSidebar-item">Dashboard</div>
        </Link>
        <Link to="/new-auction">
          <div className="dashboardSidebar-item">New Auction</div>
        </Link>
        <Link to="/my-auction">
          <div className="dashboardSidebar-item">My Auction</div>
        </Link>
        <Link to="/join-auction-code">
          {" "}
          <div className="dashboardSidebar-item">Join Auction</div>
        </Link>

        <div onClick={acpgo} className="dashboardSidebar-item">Auction Panel</div>
        <Link to="/my-profile">
          <div className="dashboardSidebar-item">My Profile</div>
        </Link>
      </div>
    </div>
  );
};

export default DashboardSidebar;
